
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8"}},[_c('path',{attrs:{"d":"M39.297 12.844L25.547.969C24.375-.047 22.5.813 22.5 2.453v6.25C9.922 8.781 0 11.36 0 23.234 0 28 3.047 32.766 6.484 35.266c1.016.78 2.579-.235 2.188-1.485-3.516-11.328 1.64-14.297 13.828-14.453v6.797c0 1.64 1.875 2.5 3.047 1.484l13.75-11.875c.86-.78.86-2.109 0-2.89z","fill":"#fff"}}),_c('path',{attrs:{"d":"M39.297 12.844L25.547.969C24.375-.047 22.5.813 22.5 2.453v6.25C9.922 8.781 0 11.36 0 23.234 0 28 3.047 32.766 6.484 35.266c1.016.78 2.579-.235 2.188-1.485-3.516-11.328 1.64-14.297 13.828-14.453v6.797c0 1.64 1.875 2.5 3.047 1.484l13.75-11.875c.86-.78.86-2.109 0-2.89z","fill":"url(#paint0_linear)"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"-1","y1":"17.5","x2":"41","y2":"17.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#F0AD4F"}})])])])
          )
        }
      }
    